var e, u;
function a() {
  if (u) return e;
  u = 1;
  function n(r, t) {
    return r == null ? void 0 : r[t];
  }
  return e = n, e;
}
export {
  a as __require
};
